import { getDisplayNameByPath } from '.';
import { KissMetrics } from '../shared/services';

const trackViewedPage = (pathname: string) => {
  const pageName = getDisplayNameByPath(pathname);
  KissMetrics.trackEvent('Account - Viewed Page', { PageName: pageName });
};

export default trackViewedPage;
